var render = function (_h,_vm) {var _c=_vm._c;return _vm._m(0)}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"my-5 text-center"},[_c('h3',[_vm._v("That request is not allowed.")])])}]

export { render, staticRenderFns }